<template> </template>

<script>
import ReportBox from './ReportBox';
import LineChart from '@/components/Charts/LineChart';

export default {
	components: {
		ReportBox,
		LineChart,
	},
};
</script>
